import axios from "axios";

// Form-encoded POST to the Aivio API (cost estimate, email codes, password reset).
export const postForm = (path, fields) => {
  const data = new FormData();
  Object.entries(fields).forEach(([key, value]) => data.append(key, value));
  return axios({ method: "post", url: `${process.env.REACT_APP_API_URL}${path}`, headers: { "api-key": `${process.env.REACT_APP_API_KEY}` }, data });
};

// The API's own message for a failed request, or a generic one.
export const errorText = (error) => error?.response?.data?.detail || error?.response?.data?.message || "Something went wrong. Please try again.";

// Seconds before another code can be requested (matches the API's resend limit).
export const RESEND_SECONDS = 60;
